// Define the Click and Collect functionality in the global theme namespace
window.theme = window.theme || {};
window.theme.ClickAndCollect = (function() {
  const selectors = {
    openButton: "[data-pickup-availability-modal-open]",
    closeButton: ".js-modal-close-pickup-availability-modal",
    modal: "#PickupAvailabilityModal",
    productTitle: "[data-pickup-availability-modal-product-title]",
    container: "[data-store-availability-container]",
    clickAndCollectDrawer: "#clickAndCollectDrawer",
  };

  const classes = {
    isActive: "is-active",
  };

  const fetchClickAndCollectAvailability = async (variantId) => {
    try {
      // Use provided variantId or try to get it from the page
      if (!variantId) {
        const productJsonElem = document.getElementById("ProductJson");
        if (!productJsonElem) {
          console.error("No product selected");
          return;
        }

        const productJson = JSON.parse(productJsonElem.textContent);
        variantId = productJson?.variant_id;
        
        if (!variantId) {
          console.error("No variant ID found for click and collect");
          return;
        }
      }

      // Fetch the click-and-collect section
      const response = await fetch(
        `${window.Shopify.routes.root}variants/${variantId}/?section_id=click-and-collect`
      );
      const text = await response.text();

      const container = document.querySelector(selectors.container);
      if (container) {
        // Clear previous content
        container.innerHTML = "";

        const pickupAvailabilityHTML = new DOMParser()
          .parseFromString(text, "text/html")
          .querySelector(".shopify-section");

        if (pickupAvailabilityHTML) {
          container.appendChild(pickupAvailabilityHTML);
        }
      }

      // Fetch the click-and-collect-drawer section
      const drawerResponse = await fetch(
        `${window.Shopify.routes.root}variants/${variantId}/?section_id=click-and-collect-drawer`
      );
      const drawerText = await drawerResponse.text();

      const drawerContainer = document.querySelector(
        selectors.clickAndCollectDrawer
      );
      if (drawerContainer) {
        const drawerHTML = new DOMParser()
          .parseFromString(drawerText, "text/html")
          .querySelector(".shopify-section");

        if (drawerHTML) {
          drawerContainer.innerHTML = "";
          drawerContainer.appendChild(drawerHTML);
        }
      }    

      // Initialize modal functionality after content is loaded
      initializeModal();
    } catch (error) {
      console.error(
        "Error initializing click and collect availability:",
        error
      );
    }
  };

  const initializeModal = () => {
    const modal = document.querySelector(selectors.modal);

    if (!modal) {
      return;
    }

    const openButtons = document.querySelectorAll(selectors.openButton);
    const closeButton = modal.querySelector(selectors.closeButton);
    const productTitle = document.querySelector("h1");
    const modalProductTitle = modal.querySelector(selectors.productTitle);

    const openModal = () => {
      modal.classList.add(classes.isActive);

      // Set product title in modal
      if (productTitle && modalProductTitle) {
        modalProductTitle.textContent = productTitle.textContent;
      }

      // Trap focus within modal
      trapFocus(modal);

      // Listen for escape key
      document.addEventListener("keydown", handleEscapeKey);
    };

    const closeModal = () => {
      modal.classList.remove(classes.isActive);

      // Remove event listeners
      document.removeEventListener("keydown", handleEscapeKey);
    };

    const handleEscapeKey = (event) => {
      if (event.key === "Escape") {
        closeModal();
      }
    };

    const handleClickOutside = (event) => {
      // Close modal when click target is not the modal or its children
      if (
        modal.classList.contains(classes.isActive) &&
        !event.target.closest("#PickupAvailabilityModal") &&
        !event.target.closest(selectors.openButton)
      ) {
        closeModal();
      }
    };

    const trapFocus = (element) => {
      const focusableElements = element.querySelectorAll(
        'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
      );

      if (focusableElements.length === 0) {
        return;
      }

      const firstElement = focusableElements[0];
      const lastElement = focusableElements[focusableElements.length - 1];

      firstElement.focus();

      element.addEventListener("keydown", (event) => {
        if (event.key === "Tab") {
          if (event.shiftKey && document.activeElement === firstElement) {
            event.preventDefault();
            lastElement.focus();
          } else if (
            !event.shiftKey &&
            document.activeElement === lastElement
          ) {
            event.preventDefault();
            firstElement.focus();
          }
        }
      });
    };

    // Add click event listeners
    openButtons.forEach((button) => {
      button.addEventListener("click", openModal);
    });

    if (closeButton) {
      closeButton.addEventListener("click", closeModal);
    }

    // Add click outside listener
    document.addEventListener("click", handleClickOutside);
  };

  // Initialize on page load
  document.addEventListener('DOMContentLoaded', () => {
    fetchClickAndCollectAvailability();
  });

  // Return public API
  return {
    update: fetchClickAndCollectAvailability
  };
})();
